export const balanceConstants = {
    BALANCE_REQUEST: 'BALANCE_REFRESH_REQUEST',
    BALANCE_SUCCESS: 'BALANCE_REFRESH_SUCCESS',
    BALANCE_FAILURE: 'BALANCE_REFRESH_FAILURE',
    TRANSACTIONS_REQUEST: 'TRANSACTIONS_REFRESH_REQUEST',
    TRANSACTIONS_SUCCESS: 'TRANSACTIONS_REFRESH_SUCCESS',
    TRANSACTIONS_FAILURE: 'TRANSACTIONS_REFRESH_FAILURE',
};
